import { render, staticRenderFns } from "./MenuUte.vue?vue&type=template&id=5bf7e302&"
import script from "./MenuUte.vue?vue&type=script&lang=js&"
export * from "./MenuUte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports